import { useCheckFailure } from './useCheckFailure';

type AvailabilityQuery = {
  data?: unknown;
  error: unknown;
  errorUpdatedAt: number;
  dataUpdatedAt: number;
  isFetching: boolean;
};

export function useAvailabilityCheck(query: AvailabilityQuery) {
  const { isCheckFailed, isRetrying } = useCheckFailure(query);
  const isAvailabilityUnknown = isCheckFailed && query.data === undefined;

  return { isAvailabilityUnknown, isRetrying: isAvailabilityUnknown && isRetrying };
}
